import { Footer } from 'components/footer'
import { Gallery } from 'components/gallery'
import { Header } from 'components/header'
import { Share } from 'components/share'
import { episodes } from 'data/episodes'
import { gallery } from 'data/gallery'
import { interviews } from 'data/interviews'
import { stories } from 'data/stories'

import { Intro } from './parts/intro'
import { Timeline } from './parts/timeline'

export const Home = () => (
  <>
    <Header />
    <Intro />
    <Gallery
      type="video"
      title="эпизоды"
      data={episodes}
      slidePerView={false}
    />
    <Timeline />
    <Gallery type="video" title="истории" data={stories} slidePerView={false} />
    <Gallery type="image" title="галерея" data={gallery} slidePerView />
    <Gallery
      type="video"
      title="интервью"
      data={interviews}
      slidePerView={false}
    />
    <Share />
    <Footer />
  </>
)
